"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoyalMailIdentifiers$ = exports.RoyalMailIdentifiers$outboundSchema = exports.RoyalMailIdentifiers$inboundSchema = void 0;
exports.royalMailIdentifiersToJSON = royalMailIdentifiersToJSON;
exports.royalMailIdentifiersFromJSON = royalMailIdentifiersFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.RoyalMailIdentifiers$inboundSchema = z.object({
    udprn: z.nullable(z.string()),
    umprn: z.nullable(z.number().int()),
});
/** @internal */
exports.RoyalMailIdentifiers$outboundSchema = z.object({
    udprn: z.nullable(z.string()),
    umprn: z.nullable(z.number().int()),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var RoyalMailIdentifiers$;
(function (RoyalMailIdentifiers$) {
    /** @deprecated use `RoyalMailIdentifiers$inboundSchema` instead. */
    RoyalMailIdentifiers$.inboundSchema = exports.RoyalMailIdentifiers$inboundSchema;
    /** @deprecated use `RoyalMailIdentifiers$outboundSchema` instead. */
    RoyalMailIdentifiers$.outboundSchema = exports.RoyalMailIdentifiers$outboundSchema;
})(RoyalMailIdentifiers$ || (exports.RoyalMailIdentifiers$ = RoyalMailIdentifiers$ = {}));
function royalMailIdentifiersToJSON(royalMailIdentifiers) {
    return JSON.stringify(exports.RoyalMailIdentifiers$outboundSchema.parse(royalMailIdentifiers));
}
function royalMailIdentifiersFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.RoyalMailIdentifiers$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'RoyalMailIdentifiers' from JSON`);
}
//# sourceMappingURL=royalmailidentifiers.js.map